import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

const BACKEND_URL = environment.apiUrl + '/match';
const BACKEND_URL_CENTRAL = environment.socketUrl2;


@Injectable({ providedIn: "root" })
export class MatchService {
    private matches: any[] = [];
    private matchE: any;
    private reportsLD: any[] = [];
    private matchesUpdated = new Subject<{ matches: any[] }>();
    private matchEUpdated = new Subject<{ result: any }>();
    private reportsLDUpdated = new Subject<{ reportsLD: any[] }>();
    constructor(private http: HttpClient) { }

    getMatches(status, end, sort) {
        const query = `?status=${status}&end=${end}&sort=${sort}`;
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + '/getMatches' + query)
            .subscribe((data:any) => {
                // this.matches = data.result;
                this.matchesUpdated.next({
                    // matches: [...this.matches],
                    matches: data,
                });
            });;
    }

    getUpdateMatchesListner() {
        return this.matchesUpdated.asObservable();
    }

    

    getMatchById(matchId: string) {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + "/getMatchById/" + matchId)
            .subscribe((matchData) => {
                this.matchE = matchData;
                this.matchEUpdated.next({
                    result: this.matchE.result
                });
            });
    }

    getUpdateMatchEListner() {
        return this.matchEUpdated.asObservable();
    }

    pdc(eventId) {
        return this.http.post<{ message: string, status: string, token: number, result: any }>(BACKEND_URL + '/pdc/' + eventId, {});
    }

    getUserMatchPdc(eventId) {
        return this.http.get(BACKEND_URL + '/getUserMatchPdc/' + eventId);
    }

    getLendenReport() {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + "/getClientLendenReport")
            .subscribe((data) => {
                this.reportsLD = data.result;
                this.reportsLDUpdated.next({
                    reportsLD: [...this.reportsLD]
                });
            });
    }

    getUpdateLendenReportListner() {
        return this.reportsLDUpdated.asObservable();
    }

    gettv(body) {
        return this.http.post(BACKEND_URL_CENTRAL + '/cm-api/match/getSingletv', body)
    }

    getCentralPanelSession(data:any){
         return this.http.post(BACKEND_URL_CENTRAL + '/cm-api/session/getSessionByStatus', data)
    }
}